/* ===========================================================================
 * 08 Left - Withdrawal Button  (EU Directive 2023/2673, effective 2026-06-19)
 * ---------------------------------------------------------------------------
 * A clearly labeled storefront control that lets an EU buyer exercise their
 * 14-day right of withdrawal. Click -> a TWO-STEP popup: (1) enter order
 * reference + name + email (+ optional reason), (2) review + confirm. On
 * confirm we POST to the withdrawal-submit edge function, which records the
 * request and emails the buyer an acknowledgment (durable medium) + notifies
 * the studio.
 *
 * Trigger: any element with class "ol-wd-btn" (the Liquid footer block adds a
 * link/button with that class). Loads once.
 *
 * Pure ASCII (special chars as HTML entities) so a paste can't corrupt it.
 * ======================================================================== */
(function () {
  "use strict";
  if (window.__olWithdrawalLoaded) return;
  window.__olWithdrawalLoaded = true;

  var VERSION = "2026-06-17.1";
  console.log("%c[08L withdrawal] " + VERSION, "color:#0a0a0a;background:#f9cb0c;padding:2px 6px;border-radius:3px;font-weight:700");

  var API = (window.__OL_WD_API || "https://mxzgicvmxmgrhzlvomim.supabase.co/functions/v1") + "/withdrawal-submit";
  var INK = "#0a0a0a", YELLOW = "#f9cb0c", RED = "#c42126";
  var FONT = '"proxima-nova","Proxima Nova",-apple-system,BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif';

  var state = { open: false, cssDone: false, step: 1, data: null };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  var emailOk = function (e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); };

  // ---- styles ------------------------------------------------------------
  function injectCSS() {
    if (state.cssDone) return; state.cssDone = true;
    var c = ""
      + ".olw-overlay{position:fixed;inset:0;background:rgba(10,10,10,.55);display:flex;align-items:flex-start;justify-content:center;z-index:999999;padding:30px 16px;font-family:" + FONT + ";-webkit-font-smoothing:antialiased;opacity:0;transition:opacity .18s;overflow-y:auto}"
      + ".olw-overlay.in{opacity:1}"
      + ".olw-modal{background:#fff;color:" + INK + ";width:100%;max-width:520px;border:1.5px solid " + INK + ";border-radius:12px;padding:28px 28px 24px;position:relative;transform:translateY(8px);transition:transform .18s;box-sizing:border-box;margin:auto}"
      + ".olw-overlay.in .olw-modal{transform:none}"
      + ".olw-modal *{box-sizing:border-box}"
      + ".olw-close{position:absolute;top:10px;right:13px;background:none;border:0;font-size:27px;line-height:1;cursor:pointer;color:" + INK + ";opacity:.5}"
      + ".olw-close:hover{opacity:1}"
      + ".olw-eyebrow{font-size:11px;letter-spacing:.16em;text-transform:uppercase;font-weight:700;opacity:.55;margin-bottom:6px}"
      + ".olw-h{font-size:23px;font-weight:800;letter-spacing:-.3px;margin:0 0 6px;line-height:1.14}"
      + ".olw-sub{font-size:13px;opacity:.7;margin:0 0 18px;line-height:1.5}"
      + ".olw-field{margin-bottom:13px}"
      + ".olw-field label{display:block;font-size:11px;letter-spacing:.06em;text-transform:uppercase;font-weight:700;margin-bottom:5px;opacity:.8}"
      + ".olw-field input,.olw-field textarea{width:100%;font:inherit;font-size:14px;padding:11px 13px;border:1.5px solid " + INK + ";background:#fff;color:" + INK + ";border-radius:7px}"
      + ".olw-field textarea{min-height:70px;resize:vertical}"
      + ".olw-field .opt{font-weight:400;opacity:.5;text-transform:none;letter-spacing:0}"
      + ".olw-hp{position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden}"
      + ".olw-review{background:#faf9f6;border:1px solid rgba(10,10,10,.12);border-radius:8px;padding:14px 16px;margin:4px 0 16px}"
      + ".olw-review .row{display:flex;justify-content:space-between;gap:14px;font-size:13.5px;padding:3px 0}"
      + ".olw-review .row .k{color:#666}"
      + ".olw-review .row .v{font-weight:700;text-align:right;word-break:break-word}"
      + ".olw-btn{display:block;width:100%;margin-top:6px;padding:15px;font:inherit;font-size:13px;letter-spacing:.1em;text-transform:uppercase;font-weight:700;background:" + INK + ";color:#fff;border:1.5px solid " + INK + ";border-radius:8px;cursor:pointer;transition:background .12s,color .12s}"
      + ".olw-btn:hover{background:" + YELLOW + ";color:" + INK + "}"
      + ".olw-btn[disabled]{opacity:.6;cursor:default}"
      + ".olw-back{display:block;width:100%;margin-top:9px;padding:6px;font:inherit;font-size:12.5px;background:none;border:0;cursor:pointer;text-decoration:underline;color:" + INK + ";opacity:.65}"
      + ".olw-back:hover{opacity:1}"
      + ".olw-msg{font-size:13px;margin-top:11px;min-height:16px;line-height:1.45}"
      + ".olw-msg.err{color:" + RED + "}"
      + ".olw-note{font-size:11.5px;opacity:.55;text-align:center;margin-top:13px;line-height:1.5}"
      + ".olw-done{text-align:center;padding:8px 0 4px}"
      + ".olw-done .olw-check{display:inline-flex;align-items:center;justify-content:center;width:46px;height:46px;border-radius:50%;background:" + YELLOW + ";margin-bottom:13px;font-size:24px;font-weight:800}"
      + ".olw-done h4{margin:0 0 7px;font-size:18px;font-weight:800}"
      + ".olw-done p{margin:0 auto;font-size:13.5px;opacity:.75;line-height:1.55;max-width:360px}";
    var tag = document.createElement("style");
    tag.id = "olw-style"; tag.textContent = c;
    document.head.appendChild(tag);
  }

  // ---- popup -------------------------------------------------------------
  function open() {
    if (state.open) return;
    state.open = true; state.step = 1; state.data = null;
    window.__OL_MODAL = true;
    injectCSS();

    var ov = document.createElement("div");
    ov.className = "olw-overlay";
    ov.innerHTML = '<div class="olw-modal" role="dialog" aria-modal="true" aria-label="Right of withdrawal">'
      + '<button type="button" class="olw-close" aria-label="Close">&times;</button>'
      + '<div class="olw-body"></div></div>';
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add("in"); });

    function close() {
      ov.classList.remove("in");
      setTimeout(function () { ov.remove(); state.open = false; window.__OL_MODAL = false; document.removeEventListener("keydown", onKey); }, 180);
    }
    function onKey(e) { if (e.key === "Escape") close(); }
    document.addEventListener("keydown", onKey);
    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
    ov.querySelector(".olw-close").addEventListener("click", close);

    var body = ov.querySelector(".olw-body");

    function renderForm() {
      var d = state.data || {};
      body.innerHTML = ''
        + '<div class="olw-eyebrow">Right of withdrawal</div>'
        + '<h3 class="olw-h">Cancel a purchase</h3>'
        + '<p class="olw-sub">If you are an EU customer exercising your 14 day right of withdrawal, tell us which order and we will email you a confirmation. You do not need to give a reason.</p>'
        + '<div class="olw-field"><label>Order reference</label>'
        + '<input type="text" class="olw-f-ref" autocomplete="off" placeholder="e.g. #1234 (from your confirmation email)" value="' + esc(d.order_ref || "") + '"></div>'
        + '<div class="olw-field"><label>Full name</label>'
        + '<input type="text" class="olw-f-name" autocomplete="name" value="' + esc(d.full_name || "") + '"></div>'
        + '<div class="olw-field"><label>Email <span class="opt">(where we send your confirmation)</span></label>'
        + '<input type="email" class="olw-f-email" autocomplete="email" value="' + esc(d.email || "") + '"></div>'
        + '<div class="olw-field"><label>Reason <span class="opt">optional</span></label>'
        + '<textarea class="olw-f-reason" placeholder="Not required.">' + esc(d.reason || "") + '</textarea></div>'
        + '<div class="olw-hp"><label>Company<input type="text" class="olw-f-company" tabindex="-1" autocomplete="off"></label></div>'
        + '<button type="button" class="olw-btn olw-continue">Continue</button>'
        + '<div class="olw-msg"></div>'
        + '<p class="olw-note">A confirmation of receipt is emailed to you. Personalized or made to order items may be exempt from the right of withdrawal.</p>';

      var msg = body.querySelector(".olw-msg");
      body.querySelector(".olw-continue").addEventListener("click", function () {
        var ref = body.querySelector(".olw-f-ref").value.trim();
        var name = body.querySelector(".olw-f-name").value.trim();
        var email = body.querySelector(".olw-f-email").value.trim();
        var reason = body.querySelector(".olw-f-reason").value.trim();
        var company = body.querySelector(".olw-f-company").value;
        msg.className = "olw-msg err";
        if (!ref) { msg.textContent = "Please enter your order reference."; return; }
        if (!name) { msg.textContent = "Please enter your full name."; return; }
        if (!email || !emailOk(email)) { msg.textContent = "Please enter a valid email address."; return; }
        msg.textContent = "";
        state.data = { order_ref: ref, full_name: name, email: email, reason: reason, company: company };
        state.step = 2; renderReview();
      });
    }

    function renderReview() {
      var d = state.data;
      body.innerHTML = ''
        + '<div class="olw-eyebrow">Step 2 of 2 &middot; Confirm</div>'
        + '<h3 class="olw-h">Confirm your withdrawal</h3>'
        + '<p class="olw-sub">Please review the details below, then confirm. By confirming, you request to withdraw from this purchase.</p>'
        + '<div class="olw-review">'
        + '<div class="row"><span class="k">Order reference</span><span class="v">' + esc(d.order_ref) + '</span></div>'
        + '<div class="row"><span class="k">Name</span><span class="v">' + esc(d.full_name) + '</span></div>'
        + '<div class="row"><span class="k">Email</span><span class="v">' + esc(d.email) + '</span></div>'
        + (d.reason ? '<div class="row"><span class="k">Reason</span><span class="v">' + esc(d.reason) + '</span></div>' : '')
        + '</div>'
        + '<button type="button" class="olw-btn olw-confirm">Confirm withdrawal</button>'
        + '<button type="button" class="olw-back">Back to edit</button>'
        + '<div class="olw-msg"></div>';

      var msg = body.querySelector(".olw-msg");
      body.querySelector(".olw-back").addEventListener("click", function () { state.step = 1; renderForm(); });
      body.querySelector(".olw-confirm").addEventListener("click", function () {
        var btn = body.querySelector(".olw-confirm");
        btn.disabled = true; btn.textContent = "Sending...";
        msg.className = "olw-msg"; msg.textContent = "";
        fetch(API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(d)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (res.ok && res.j && res.j.ok) { renderDone(d.email); return; }
            var err = res.j && res.j.error;
            btn.disabled = false; btn.textContent = "Confirm withdrawal";
            msg.className = "olw-msg err";
            msg.textContent = err === "rate_limited"
              ? "Too many requests just now. Please wait a few minutes and try again."
              : "Sorry, something went wrong. Please email info@08left.com and we will help.";
          })
          .catch(function () {
            btn.disabled = false; btn.textContent = "Confirm withdrawal";
            msg.className = "olw-msg err";
            msg.textContent = "Network error. Please check your connection and try again.";
          });
      });
    }

    function renderDone(email) {
      body.innerHTML = ''
        + '<div class="olw-done">'
        + '<div class="olw-check">&#10003;</div>'
        + '<h4>Request received</h4>'
        + '<p>We have emailed a confirmation to <strong>' + esc(email) + '</strong>. Our team will review your withdrawal and follow up with the next steps. You can close this window.</p>'
        + '</div>'
        + '<button type="button" class="olw-btn olw-done-close">Done</button>';
      body.querySelector(".olw-done-close").addEventListener("click", close);
    }

    renderForm();
  }

  function wire() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest(".ol-wd-btn") : null;
      if (!btn) return;
      e.preventDefault();
      open();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wire);
  else wire();
})();
